import { TakeEffect, takeEvery } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_OVERVIEW_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import {
  API_GET_EMPLOYEES_IMPORTS_OVERVIEW,
  KEY_GET_EMPLOYEES_IMPORTS_OVERVIEW,
} from '../constants';
import { MOCK_RESPONSE_GET_EMPLOYEES_IMPORTS_OVERVIEW } from '../mocks';

type RequestEmployeesImportsOverview = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_OVERVIEW_PATH_KEY
>['request']['path'];

export type CallParamsGetEmployeesImportsOverview = Omit<
  RequestEmployeesImportsOverview,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetEmployeesImportsOverview = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_OVERVIEW_PATH_KEY
>['response']['body'];

type CallErrorGetEmployeesImportsOverview = GenericApiError;

type CallSelectorsGetEmployeesImportsOverview = {
  pendingReviewImport: CallResponseGetEmployeesImportsOverview | undefined;
  jobStillRunning: CallResponseGetEmployeesImportsOverview | undefined;
};

export const getEmployeesImportsOverviewCall = createGeneralCall<
  CallParamsGetEmployeesImportsOverview,
  CallResponseGetEmployeesImportsOverview,
  CallErrorGetEmployeesImportsOverview,
  CallSelectorsGetEmployeesImportsOverview
>({
  id: KEY_GET_EMPLOYEES_IMPORTS_OVERVIEW,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_GET_EMPLOYEES_IMPORTS_OVERVIEW(org);
  },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_EMPLOYEES_IMPORTS_OVERVIEW : undefined,
  selectors: {
    pendingReviewImport: ({ selectors }) =>
      createSelector(selectors.response, res =>
        res?.status === 'WAITING_REVIEW' ? res : undefined,
      ),
    jobStillRunning: ({ selectors }) =>
      createSelector(selectors.response, res => (res?.status === 'JOB_RUNNING' ? res : undefined)),
  },
  cancellable: true,
  takeEffect: takeEvery as unknown as TakeEffect,
  rsmOptions: {
    doubleRun: false,
  },
});
